import { EmspUserInvoiceBaseModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/emsp-user-invoice-base.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';

export interface EmspBoInvoiceListActionsHeaderProps
  extends HeaderContext<EmspUserInvoiceBaseModel, unknown> {}

export const EmspBoInvoiceListActionsHeader =
  (): // props: EmspBoInvoiceListActionsHeaderProps,
  ReactNode => {
    // RENDER ////////////////////////////////////////////////////////////////////

    return null;
  };
